// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2kKtX","icon":"SortAdornment_icon__2bcT1","up":"SortAdornment_up__Cy7PI","down":"SortAdornment_down__1R14Q","active":"SortAdornment_active__ziQR_"};